<template>
  <div class="fillcontain">
    <head-top></head-top>
    <header class="admin_title">个人信息</header>
    <div class="admin_set">
      <el-form :inline="true">
        <el-form-item label="用户名">
          <el-input v-model="username" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="phone"
            disabled
            placeholder="手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="code" placeholder="验证码" clearable>
            <template slot="append">
              <el-button v-show="codeshow" @click="getCode"
                >获取验证码</el-button
              >
              <el-button v-show="!codeshow">{{ count }} s</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="微信号">
          <el-input
            v-model="weixin"
            placeholder="微信"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="QQ号">
          <el-input
            v-model="QQ"
            placeholder="QQ号"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
                <el-button type="primary" @click="change" class="submit_btn"
            >确定修改</el-button
          >
    </div>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";
export default {
  data() {
    return {
      username: localStorage.getItem("username"),
      radio: true,
      phone: "",
      QQ: "",
      weixin: "",
      code: "",
      codeshow: true,
      count: "",
      timer: null,
    };
  },
  created() {
    this.getPersonal();
  },
  components: {
    HeadTop,
  },
  watch: {
    username: function () {
      this.username = this.username.replace(/[\W]/g, "");
    },
  },
  computed: {},
  methods: {
    getPersonal() {
      myAxios
        .get(`client_user/Personal/v1?username=${this.username}`)
        .then((res) => {
          this.balance = res.data.balance;
          this.phone = res.data.phone;
          this.QQ = res.data.QQ;
          this.weixin = res.data.weixin;
        });
    },
    change() {
      var that = this;
      if (this.code == "" || this.phone == "") {
        this.$notify.error({
          title: "错误",
          message: "请填写手机号与验证码",
          offset: 100,
        });
        return;
      }
      myAxios
        .post(
          `client_user/UpdateUserInfo/v1?username=${this.username}&phone=${this.phone}&QQ=${this.QQ}&weixin=${this.weixin}&code=${this.code}`
        )
        .then((res) => {
          if (res.code == 0) {
            // localStorage.setItem("token", res.data.token);
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success",
            });
            that.$router.go(-1);
          } else {
            this.$notify.error({
              title: "错误",
              message: res.message,
              offset: 100,
            });
            return false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCode() {
      var that = this;
      myAxios
        .get(`client_login/GetSmsCode/v1?phone=${this.phone}`)
        .then((res) => {
          if (res.data.code == 0) {
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeshow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeshow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: res.data.message,
              offset: 100,
            });
          }
        })
        .catch(function (error) {});
      const TIME_COUNT = 59;
    },
  },
};
</script>

<style lang="less">
@import "../style/mixin";
.explain_text {
  margin-top: 20px;
  text-align: center;
  font-size: 20px;
  color: #333;
}
.admin_set {
  width: 40%;
  padding: 20px;
  background-color: #f9fafc;
  min-height: 400px;
  margin: 20px auto 0;
  border-radius: 10px;
  ul > li {
    padding: 20px;
    span {
      color: #666;
    }
  }
}
.admin_title {
  margin-top: 20px;
  .sc(24px, #666);
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  margin-top: 10px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.register {
  margin-top: 5px;
  font-size: 12pt;
  cursor: pointer;
}
.login_page {
  background-color: #324057;
}
.manage_tip {
  position: absolute;
  width: 100%;
  top: -100px;
  left: 0;
  p {
    font-size: 34px;
    color: #fff;
  }
}
.form_contianer {
  .wh(340px, 510px);
  .ctp(340px, 260px);
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  background-color: #fff;
  top: 40%;
  .submit_btn {
    width: 100%;
    font-size: 16px;
  }
}
.tip {
  font-size: 12px;
  color: red;
}
.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 1s;
}
.form-fade-enter,
.form-fade-leave-active {
  transform: translate3d(0, -50px, 0);
  opacity: 0;
}
</style>
